import { gql } from '@apollo/client';

import {
  V2GetInsightDocument,
  type V2GetInsightQuery,
  type V2GetInsightQueryVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    query V2GetInsight($id: UUID!) {
      insightV2(id: $id) {
        id
        messages {
          id
          text
          createdAt
          sender
          optionRenderType
          contentUrl
          transcript
          assets {
            id
            name
            url
            description
            createdAt
            updatedAt
          }
          metadata {
            isConversationOver
            maxSelections
            options {
              label
              value
              assets {
                id
                name
                url
                description
                createdAt
                updatedAt
              }
            }
            required
            type
            assistantQuestion
            questionId
          }
        }
        contact {
          id
          firstName
          lastName
          email
          phone
        }
        progress
      }
    }
  `;
}

export const V2_GET_INSIGHT = V2GetInsightDocument;
export type { V2GetInsightQuery, V2GetInsightQueryVariables };
